export interface MetroidError {
  code: string;
  code_details: string;
  payment_method_type: string;
}

export interface MetroidAccountIdType {
  brand: string;
  businessUnit: string;
  userId: string;
}

export interface MetroidSessionTokenType {
  referenceKey: string;
  secret: string;
}

export interface MetroidCustomFieldsType {
  ExternalUserId__c: string;
}

export interface MetroidPaymentMethodResultType {
  payment_method_id: string;
  payment_method_type: string;
}

export enum PaymentMethodType {
  ACH = 'ACH:Zillow:Zillow Rental Network',
  CREDIT_CARD = 'CC:Zillow:Zillow Rental Network',
}

export const ZUORA_ERROR_CODES = {
  Attempt_Exceed_Limitation: 'Attempt_Exceed_Limitation',
};

export const mapZuoraPaymentMethodError = (e: MetroidError) => {
  if (e?.code === 'ZE-UI') {
    if (e.code_details.includes('Field [AVS NAME] exceeded max length of [30]') && e.payment_method_type === 'ACH') {
      return 'Bank name, and account holder name must be under 30 characters.';
    } else if (e.code_details.includes('Field [Address verification service ZIP code] exceeded max length of [10]')) {
      return 'Zip length must be under 10 characters.';
    } else if (e.code_details.includes('Field [Check DDA] exceeded max length of [19]')) {
      return 'Account name must be under 19 characters.';
    } else if (e.code_details.includes('Customer Advises Not Authorized')) {
      return 'Please use a different payment method or contact support';
    } else if (e.code_details.includes('Call Voice Center')) {
      return "We couldn't add your payment method. Check that your card details are correct, or try a different card. If the issue continues, contact your bank.";
    }
  }
  return 'Failed to add payment method, please try again.';
};
